import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const Blueprints = () => {

  const servicesFaqData = [
    { 
        question: "What customisation options are available for blueprint printing?", 
        answer: "Printingy offers various customisation options for printing blueprints, including sizes, materials, and finishes. Our services support detailed layouts for house blueprint plans, apartment floor plans blueprints, and more. We offer advanced printing techniques for building blueprint 3D models to create visually accurate and durable prototypes."
    },
    { 
        question: "Does Printingy handle bulk orders for blueprint printing?", 
        answer: "Yes, Printingy specialises in bulk blueprint printing, catering to large-scale projects for architects, engineers, and construction firms. Bulk printing ensures consistent quality and cost-effective solutions, making it ideal for housing developments, commercial buildings, and infrastructure projects."
    },
    { 
        question: "What industries benefit from blueprint printing services?", 
        answer: "Blueprint printing services are widely used in architecture, engineering, construction, and urban planning industries. Professionals rely on printing blueprints for building construction, house blueprint plans, and apartment layouts to support their design and planning processes. Printingy provides tailored solutions to meet the unique requirements of each industry."
    },
    { 
        question: "Does Printingy provide 3D printing services for building blueprints?", 
        answer: "Printingy offers building blueprint 3D printing, producing detailed and accurate models. These models are ideal for visualising complex designs, presenting concepts to clients, and identifying potential challenges before construction begins. Our 3D printing services are crafted with precision to meet your specifications."
    },
    { 
        question: "What is the typical turnaround time for blueprint printing?", 
        answer: "Turnaround times for blueprint printing depend on the size and complexity of the order. Standard orders for house blueprint plans or apartment layouts are typically completed within a few business days. We provide clear timelines and prioritise meeting your deadlines for highly customised designs or larger volumes."
    },
    { 
        question: "What materials are used for blueprint printing?", 
        answer: "We use high-quality materials to print blueprints, including durable paper and eco-friendly options. These materials ensure clear and sharp visuals for technical plans or promotional presentations. For building blueprint 3D printing, we use strong and flexible filaments to produce detailed and reliable models."
    },
    { 
        question: "Are eco-friendly options available for blueprint printing?", 
        answer: "Yes, Printingy is committed to sustainability and offers eco-friendly options for printing blueprints. We use recyclable materials, non-toxic inks, and sustainable production methods to minimise environmental impact. These options are ideal for professionals seeking environmentally responsible printing solutions."
    },
    { 
        question: "What factors should I consider when ordering blueprint printing?", 
        answer: "When ordering blueprint printing, consider the purpose, scale, and level of detail required. Selecting the right materials, sizes, and finishing options ensures your plans and models are effective and visually precise. Printingy’s team guides to help you achieve the best results for your project."
    },
    { 
        question: "How do I place an order for blueprint printing services?", 
        answer: "Placing an order is simple and efficient. Visit our website and select your preferences for blueprint printing, including sizes and customisation options. Upload your design files or share your requirements, and our team will guide you through the process. We ensure a seamless experience from design approval to delivery."
    },
    { 
        question: "What makes bulk blueprint printing cost-effective?", 
        answer: "Bulk blueprint printing reduces per-unit costs, making it a cost-effective choice for large-scale projects. Printingy delivers high-quality results at competitive prices by consolidating materials and streamlining production. Our bulk blueprint printing services ensure exceptional value while maintaining professional standards."
    }
  ];
  const [pageTitle, setPageTitle] = useState('Blueprints Printing');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes
  return (
    <div>
       <MetaManager 
  title="Custom Envelopes for Businesses with Personalised Designs"
  description="High-quality custom envelopes for business. Personalised envelopes and envelopes design and printing services tailored for professional needs."
  keywords="Printing of Blueprints,
Blueprint of building construction,
Building blueprint 3D,
House blueprint plans,
Apartment floor plans blueprints,
Blueprint printing
"
/>
      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Custom Blueprint Printing Services</h1>
              <h2 className="text-muted">
              Professional printing of house blueprints, floor plans, and 3D building models
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4  shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>
          Blueprints are essential for architects, engineers, and builders, providing detailed and precise plans for construction projects. Printingy offers premium-quality blueprint printing services, including blueprints for building construction, house designs, and apartment layouts.

          </p>
          
          <p>
          Our expertise includes building blueprint 3D models and apartment floor plan blueprints, enabling detailed visualisation and efficient project execution. Whether you require bulk printing for large-scale developments or customised prints for individual projects, we ensure accuracy, clarity, and durability in every order.
          </p>
          <p>With advanced printing technology and a commitment to precision, Printingy delivers high-quality house blueprint plans and related prints that meet professional standards. Trust us for reliable solutions tailored to your architectural and construction needs.
          </p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Blueprint Printing Solutions</h2>
                <h3 className="large-hed">Accurate, durable, and scalable printing services for construction projects</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert blueprint printing services for clear and detailed plans.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Customised building blueprint 3D printing for enhanced visualisation.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Precise printing of blueprints for house designs and apartment layouts.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk printing solutions for cost-effective project management.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable and eco-friendly materials for professional results.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced technology for sharp details and vibrant visuals.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnarounds and efficient order management systems.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by architects, engineers, and construction professionals nationwide
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/blueprints.jpg" // Path relative to the public folder
                  alt="High-quality apartment floor plans blueprint printing"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Blueprints Delivered On Time</h2>
            <h3 className="small-hed">Focus on your designs while we manage your blueprint printing needs</h3>
            <p>At Printingy, we specialise in delivering exceptional blueprinting services that combine precision and reliability. Whether you need house blueprint plans, building blueprint 3D models, or apartment floor plans blueprints, we ensure every print meets professional standards.</p>
            <p>Our streamlined processes guarantee timely delivery, even for bulk orders. Partner with Printingy for high-quality blueprints that support your architectural and construction goals.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default Blueprints;
